module.exports = __webpack_public_path__ + "img/img-2@2x.5c2f18c8.png";